// extracted by mini-css-extract-plugin
module.exports = {"infoBoxContainer":"oCFQGF_1oSFibiHWfb1_x"};